import { useState, useEffect } from 'react';
import { styled, alpha } from '@mui/material/styles';
import { throttle } from 'lodash-es';
import BootstrapContainer from './BootstrapContainer';
import logo from 'assets/images/mct-logo-dark@2x.png';

export const HEADER_HEIGHT = 60;
export const HEADER_SHRINK_HEIGHT = 60;

type Props = {
  className?: string;
};

const UnstyledHeader = ({ className, ...rest }: Props) => {
  const [isShrink, setIsShrink] = useState(false);

  useEffect(() => {
    const handleScroll = throttle((event: Event) => {
      const scrollOver = isShrink
        ? window.scrollY > HEADER_SHRINK_HEIGHT
        : window.scrollY > HEADER_HEIGHT;
      scrollOver !== isShrink && setIsShrink(scrollOver);
    }, 16);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isShrink]);

  return (
    <header
      id="header"
      className={`dark ${isShrink ? 'shrink' : ''} ${className}`}
      {...rest}
    >
      <div id="header-wrap" className="hide-on-print">
        <BootstrapContainer>
          <div className="header-row">
            <div id="logo" className="me-lg-5">
              <a href="/">
                <img className="logo-dark" src={logo} alt="MiTAC" />
              </a>
            </div>
          </div>
        </BootstrapContainer>
      </div>
      <div className="header-wrap-clone"></div>
    </header>
  );
};

const Header = styled(UnstyledHeader)(({ theme }) => ({
  // position: 'sticky',
  color: '#E9ECEF',
  zIndex: 999,
  top: 0,

  '@media print': {
    '.hide-on-print': {
      display: 'none',
    },
  },

  '#header-wrap': {
    // backgroundColor: '#212529',
    backgroundColor: alpha(theme.palette.common.black, 0.7),
    // position: 'fixed',
    width: '100%',
    height: 'auto',
    // zIndex: 299,
    borderBottom: `1px solid ${alpha(theme.palette.common.black, 0.7)}`,
    transition: 'height 0.2s ease 0s, background-color 0.3s ease 0s',
    backfaceVisibility: 'hidden',
  },

  '.header-row': {
    position: 'initial',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

  '#logo': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto',
    maxHeight: '100%',
    '@media (min-width: 992px)': {
      marginRight: '3rem',
    },
    '& a': {
      color: theme.palette.common.black,
      fontFamily: 'Inter, sans-serif',
      fontSize: '36px',
      width: '100%',
    },
    '& img': {
      display: 'flex',
      maxWidth: '100%',
      maxHeight: '100%',
      marginRight: 'auto',
      marginLeft: 'auto',
      height: HEADER_HEIGHT - 1,
      transition:
        'height 0.4s ease, padding 0.4s ease, margin 0.4s ease, opacity 0.3s ease',
    },
  },

  // '.header-wrap-clone': {
  //   height: HEADER_HEIGHT,
  //   transition:
  //     'height 0.4s ease, padding 0.4s ease, margin 0.4s ease, opacity 0.3s ease',
  // },

  '&.shrink': {
    '#logo img': {
      height: HEADER_SHRINK_HEIGHT - 1,
    },
    // '.header-wrap-clone': {
    //   height: HEADER_SHRINK_HEIGHT,
    // },
  },
}));

export default Header;
